import { DeliveryIndicatorHelpers, DeliveryIndicatorTypes } from '@grandvision/inventory'

type DeliveryResolverFactory = () => DeliveryIndicatorTypes.DeliveryResolver

export const deliveryResolverFactory: DeliveryResolverFactory = () => {
  return DeliveryIndicatorHelpers.defaultDeliveryResolver
}
